import { defineComponent as _defineComponent } from 'vue'
import { TransportationWaypointSortingPreview } from './WaypointSortingDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WaypointSortPreviewTransportations',
  props: {
    transportations: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})